import React from 'react';
import { motion } from 'framer-motion';
import { FaLaptopCode } from 'react-icons/fa';
import './Experience.css';

const experiences = [
  {
    role: "Software Engineer",
    company: "Impression Services",
    location: "Remote",
    date: "Aug 2025 – Present",
    logo: "/logos/impression.jpg",
    icon: <FaLaptopCode />,
    description: [
      "Solely architected and developed desk.polimate.in (web + mobile backend), delivering end-to-end workflow automation across multiple business modules.",
      "Designed and implemented complex, multi-stage workflows with role-based access control, improving operational efficiency and reducing manual intervention.",
      "Developed advanced dashboards, dynamic data tables, and filtering systems using React.js, Next.js, and Redux for real-time insights.",
      "Engineered secure authentication and authorization systems, enabling fine-grained permission management across users and roles."
    ]
  },
  {
    role: "Frontend Developer Intern",
    company: "Finosauras",
    location: "Bangalore",
    date: "Mar 2025 – Apr 2025",
    logo: "/logos/finosauras.png",
    description: [
      "Leading creative frontend development efforts, building UI components and features from scratch.",
      "Collaborated with product and backend teams to align UI features with business requirements and API structures.",
      "Implemented advanced table filtering and sorting mechanisms, improving data accessibility and usability.",
      "Focused on improving UX by refining layouts, responsiveness, and component reusability."
    ]
  },
  {
    role: "Frontend Developer Intern",
    company: "SellerGeni",
    location: "Bangalore",
    date: "Oct 2024 – Feb 2025",
    logo: "/logos/sellergeni.png",
    description: [
      "Worked closely with cross-functional teams to deliver production-ready features aligned with business needs.",
      "Enhanced user interface elements and implemented table filters to improve data presentation.",
      "Identified and resolved critical frontend and backend bugs, ensuring stable and reliable application performance.",
      "Developed backend filters for table data, improving query efficiency and response time."
    ]
  },
  {
    role: "Frontend Developer Intern",
    company: "Cuvasol Technologies",
    location: "Bangalore",
    date: "Sep 2023 – Dec 2023",
    logo: "/logos/cuvasol.png",
    description: [
      "Contributed to building interactive user interfaces for ongoing web projects using React.js and Tailwind CSS.",
      "Collaborated closely with senior developers to squash bugs and implement new features.",
      "Ensured responsive design and cross-browser compatibility across multiple pages."
    ]
  }
];

const Experience = () => {
  return (
    <section id="experience" className="section experience">
      <div className="container">
        <motion.div className="section-header" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h2 className="section-title text-gradient">Professional Journey</h2>
          <div className="title-underline"></div>
        </motion.div>

        <div className="experience-timeline">
          {experiences.map((exp, idx) => (
            <motion.div 
              key={idx} 
              className="experience-item"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.15 }}
            >
              <div className="experience-marker">
                <div className="marker-logo" style={exp.logo ? { padding: 0 } : {}}>
                  {exp.logo ? (
                    <img 
                      src={exp.logo} 
                      alt={exp.company} 
                      onError={(e) => { 
                        e.target.style.display = 'none'; 
                        if (e.target.parentNode) e.target.parentNode.innerHTML = exp.company.charAt(0); 
                      }} 
                    />
                  ) : (
                    exp.icon
                  )}
                </div>
                {idx !== experiences.length - 1 && <div className="marker-line"></div>}
              </div>
              
              <div className="experience-content hover-target">
                <div className="experience-header">
                  <div className="experience-titles">
                    <h3 className="exp-role">{exp.role}</h3>
                    <h4 className="exp-company">
                      {exp.company} <span className="exp-location">• {exp.location}</span>
                    </h4>
                  </div>
                  <div className="exp-date-badge">{exp.date}</div>
                </div>
                
                <ul className="exp-desc">
                  {exp.description.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
